import React from "react";
import SectionHeading from "@components/sectionHeading";
import { ContactLink } from "../components/ContactLink";
import Button from "@components/button";

export const DeclineApplicationNotFound = () => (
  <SectionHeading
    heading="Application not found...."
    className="margin-bottom capitalise"
    soft
    subheading={(
      <>
        Sorry your application could not be found.<br />
        Please click on the button below to start a new application.<br /><br />
        Alternatively, if you want to resume your previous application, please contact us on <ContactLink />.
        <Button elementType="a" href="/apply" className="margin-bottom apply-link">Start Application</Button>
      </>
    )}
  />
);